<template>
    <div class="modal modal-mask" style="display: block">
      <div :id="id" class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <slot name="header"></slot>
          </div>
          <div class="modal-body">
            <slot name="body"></slot>
          </div>
           <div class="modal-footer text-end" style="display: block;">
             <slot name="footer"></slot>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'modal',
  props: ['id']
}
</script>

<style>
  .modal {
      overflow-y:scroll;
  }
  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #2479bc;
    display: table;
    transition: opacity .3s ease;
  }
  .modal-body {
      background-color: #efeff4;
  }
  .modal-footer {
      margin-top: 0;
      padding: 12px;
      padding-bottom: 14px;
  }
  .modal-title {
      font-size: 20px;
      font-weight: normal;
      color: #aeaeae;
  }

</style>
